/**
 * Is using components, should go to organisms
 */
import React from 'react';
import { Flex } from './../../components/layout/Grid';
import Label from './Label';
import Switch from './Switch';

const SwitchLabel = props => {
  return (
    <Flex justifyContent="space-between" alignItems="center">
      <Label htmlFor={props.label}>{props.label}</Label>
      <Switch
        name={props.name}
        id={props.label}
        value={props.value}
        onChange={props.onChange}
        onBlur={props.onBlur}
      />
    </Flex>
  );
};

export default SwitchLabel;
